<template>
    <div class="p-5">
        <hts-card>
            <trip-content
                :trip="trip"
                is-public />
        </hts-card>
    </div>
</template>
<script lang="ts" setup>
import TripContent from '@/pages/trucker-[id]/-components/trip-info-content.vue'
import { combineTravelDetails } from '@/pages/trucker-[id]/-components/trip-utils'

const { $formatters } = useNuxtApp()
const route = useRoute()
const tripId = computed(() => route.query.c)
const loading = ref(true)
const cVisible = ref(false)

const trip = reactive<any>({
  _id: '',
  code: '',
  stages: [],
  stageNames: [],
  timeIn: null,
  timeOut: null,
  vehicleId: null,
  vehicleTempId: null,
  order: {},
  routingPositions: [],
  positions: []
})

const getData = (silence: boolean = false) => {
  if (!silence) {
    loading.value = true
  }
  $api($url.shared.trip, { uriParams: { ID: tripId.value } }).then(({ data }: any) => {
    const temp = (data?.value || {}).data || {}

    temp.travelDetails = combineTravelDetails(temp, $formatters)
    Object.assign(trip, temp)
    nextTick(() => {
      loading.value = false
    })
  })
}

const show = () => {
  Object.assign(trip, {
    _id: '',
    code: '',
    stages: [],
    stageNames: [],
    timeIn: null,
    timeOut: null,
    vehicleId: null,
    vehicleTempId: null,
    order: {}
  })
  cVisible.value = true
}
onMounted(() => {
  getData()
})

const hide = () => {
  cVisible.value = false
}

const refresh = (id?: string) => {
  if (!cVisible.value) {
    return
  }
  if (id && tripId.value !== id) {
    return
  }

  getData(true)
}

defineExpose({
  show,
  hide,
  refresh
})
</script>
